import { useEffect, useState } from "react"

import { useEvent } from "./useEvent"

export function useNextRenderCycle() {
  const [scheduledFn, setScheduledFn] = useState<(() => void) | null>()

  useEffect(() => {
    if (scheduledFn) {
      scheduledFn()
      setScheduledFn(null)
    }
  }, [scheduledFn])

  const registerFn = useEvent((fn: () => void) => {
    setScheduledFn(() => fn)
  })

  return registerFn
}
